import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CartaPorteService {
  api_url = environment.url;

  constructor(private http: HttpClient) { }

  list(params?: { service_id?: any; created_at?: any; page?: number; pageSize?: number }) {
    let httpParams = new HttpParams();
    if (params?.service_id) {
      httpParams = httpParams.set('service_id', String(params.service_id));
    }
    if (params?.created_at) {
      httpParams = httpParams.set('created_at', String(params.created_at));
    }
    if (params?.page) {
      httpParams = httpParams.set('page', String(params.page));
    }
    if (params?.pageSize) {
      httpParams = httpParams.set('pageSize', String(params.pageSize));
    }
    return this.http.get(`${this.api_url}carta-porte/list`, { params: httpParams });
  }

  getId(id: number) {
    return this.http.get(`${this.api_url}carta-porte/show/${id}`);
  }

  add(data: any) {
    return this.http.post(`${this.api_url}carta-porte/add`, data);
  }

  update(data: any, id: number) {
    return this.http.post(`${this.api_url}carta-porte/update/${id}`, data);
  }

  delete(id: number) {
    return this.http.get(`${this.api_url}carta-porte/delete/${id}`);
  }

  getTransportMeans() {
    return this.http.get(`${this.api_url}carta-porte/transport-means`);
  }

  getWeightUnits() {
    return this.http.get(`${this.api_url}carta-porte/weight-units`);
  }

  getMeasurementUnits() {
    return this.http.get(`${this.api_url}carta-porte/measurement-units`);
  }

  getUnitKeys() {
    return this.http.get(`${this.api_url}carta-porte/unit-keys`);
  }

  getCargoInsurers() {
    return this.http.get(`${this.api_url}carta-porte/cargo-insurers`);
  }

  getLogisticsTypes() {
    return this.http.get(`${this.api_url}carta-porte/logistics-types`);
  }

  getHazardousMaterialOptions() {
    return this.http.get(`${this.api_url}carta-porte/hazardous-material-options`);
  }

  downloadCfdiXml(id: number) {
    return this.http.get(`${this.api_url}carta-porte/${id}/cfdi-xml`, { responseType: 'text' });
  }

  downloadPdf(id: number) {
    return this.http.get(`${this.api_url}carta-porte/${id}/pdf`, { responseType: 'blob' });
  }

  saveCfdiJson(serviceId: number) {
    return this.http.post(`${this.api_url}carta-porte/cfdi-json/${serviceId}/save`, {});
  }

  stampCfdi(serviceId: number) {
    return this.http.post(`${this.api_url}carta-porte/cfdi/${serviceId}/stamp`, {});
  }

  getColoniasByPostalCode(postalCode: string) {
    return this.http.get(`${this.api_url}sepomex/postal-code/${postalCode}`);
  }
}
